import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

export const getNotifications = (params = '') => Http.get(`/public/user/notifications${serialize(params)}`)
export const deleteNotification = params => Http.delete(`/public/user/notifications/${params.id}`)
export const notificationByID = (params = '') => Http.get(`/public/user/notifications/${params}`)
export const notificationCreate = (params = '') => Http.post('/create-notifications', params)

export const getAllNotifications = (params = '') => Http.get(`/notifications${serialize(params)}`)
